/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import useUser from '../../Shared/UserProvider/useUser'
import React, { useEffect, useState } from 'react'
import { Accordion, Divider, Form, Header, Tab } from 'semantic-ui-react'
import HoursForm from './HoursForm'
import { useTranslation } from 'react-i18next'
import PosDaysOff from './PosDaysOff/PosDaysOff'
import {
    ExportPosOpeningButton,
} from '../../Shared/ExportPosOpeningButton/ExportPosOpeningButton'
import { isProviderACompany, isProviderAPos } from '../../../services/Provider/Provider.service'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { getPointOfSale } from '../../../services/PointOfSale/PointOfSale.service'
import AdvancedFilters from '../../Home/AdvancedFilters'
import useBreadcrumb from '../../NavBar/useBreadcrumb'


const AdminHours = () => {
    const [t] = useTranslation()
    const {user} = useUser()
    const queryClient = useQueryClient()
    const [selectedPosId, setSelectedPosId] = useState(user.getFirstPosFromLoginContext())
    const {setPaths} = useBreadcrumb()

    useEffect(() => {
        setPaths([{
            text: t('breadcrumb.home'),
            link: true,
            path: '/',
        }, {
            text: t('breadcrumb.settings'),
            link: false,
            path: '/settings',
        }])
    }, [setPaths, t])

    const {data: selectedPos} = useQuery({
        queryKey: ['pointofsales', selectedPosId],
        queryFn: () => getPointOfSale(selectedPosId),
        enabled: !!selectedPosId,
    })

    const handleSelectedPosChange = (filters) => {
        queryClient.setQueryData(['pointofsales', filters.merchantId], filters.merchantId)
        setSelectedPosId(filters.merchantId)
    }

    return (
      <Tab.Pane>
          {(isProviderACompany(user.provider) || user.isLoggedInOwnScope) && (
            <Form>
                <ExportPosOpeningButton/>
                <Divider/>
                <AdvancedFilters
                  filters={{
                      merchantId: selectedPosId,
                  }}
                  debounceTimeInMs={0}
                  onFiltersChange={handleSelectedPosChange}
                >
                    <AdvancedFilters.PosFilter/>
                </AdvancedFilters>
                <Divider/>
            </Form>
          )}

          {selectedPos &&
            <Accordion styled css={css`
                width: 100% !important;
            `} panels={[{
                key: `hoursFormAccordion`,
                title: {
                    content: <Header css={css`display: inline`}>{t('administration.hours.header')}</Header>,
                },
                content: {
                    content: <HoursForm merchant={selectedPos}/>,
                },
            }, {
                key: 'posDaysOffAccordion',
                title: {
                    content: <Header
                      css={css`display: inline`}>{t('administration.pos_days_off.pos_days_off')}</Header>,
                },
                content: {
                    content: <PosDaysOff pos={selectedPos}/>,
                },
            }]}/>
          }
      </Tab.Pane>
    )
}


export default AdminHours
